import { useHistory } from 'react-router-dom';

const useRoute = () => {
  const history = useHistory();
  const sendToLessons = (lesson, modules, course) => {
    history.push({
      pathname: '/cursos/lecciones',
      state: {
        lesson,
        modules,
        course,
      },
    });
  };

  return {
    sendToLessons,
  };
};

export default useRoute;
